<template>
  <div class="card card-user">
    <div class="image">
      <img src="static/img/background/damir-bosnjak.jpg" alt="...">
    </div>
    <div class="card-body">
      <div class="author">
        <a href="#/profile" @click.prevent="modals.classic = true">
          <img class="avatar border-gray" :src="profilePhoto" :alt="profilePhotoAlt">
        </a>
        <h5 class="title">{{ usersName }}</h5>
      </div>
      <p class="description text-center">
        <!--
        <br> 4 Accounts
        <br> 10 Active Goals
        <br> N35,700 Spendable
        -->
      </p>
    </div>
    <div class="card-footer">
    </div>
    <modal :show.sync="modals.classic" 
      footerClasses="justify-content-center" 
      body-classes="justify-content-center"
      :show-header=false>
      <center>
        <a href="" @click.prevent="$refs.fileSelector.click()">
          <img class="border-gray" :src="profilePhoto" >
        </a>
      </center>
      <template slot="footer">
        <input type="file" @change="onFileSelected" 
          style="display: none" 
          ref="fileSelector" 
          accept="image/*" />
        <p-button class="btn btn-success" round @click="$refs.fileSelector.click()">Update Photo</p-button>
      </template>
    </modal>
  </div>
</template>
<script>
  import {Modal} from 'src/components/UIComponents'
  import user from 'src/user'

  export default {

    inherit: true,
    selectedFile: null,

    components: {
      Modal
    },
    data(){
      return {
        modals: {
          classic: false
        },

        usersName: null,
        profilePhoto: 'static/img/face-0.jpg',
        profilePhotoAlt: ''
      }
    },

    methods: {
      onFileSelected (event) {
        this.selectedFile = event.target.files[0]
        this.uploadSelectedFile ()
      },

      uploadSelectedFile () {
        const formData = new FormData
        formData.append('websphereProfilePhoto', this.selectedFile, this.selectedFile.name)
        
        this.$http.post('/profiles/upload-photo', formData, {
          headers: {
            "Content-Type": "multipart/form-data"
          }
        })
        .then(response => {
          this.profilePhoto = process.env.VUE_APP_PHOTO_DIR_PUBLIC + response.data
          
        })
        .catch(error =>{
          
        })

      },

      
      getUsersName () {
        user.profile(this.$http, userData => {
          if(userData) {
            this.usersName = user.firstName + ' ' + user.lastName
            this.profilePhotoAlt = this.usersName
            
            if (user.profilePhoto) {
              this.profilePhoto = process.env.VUE_APP_PHOTO_DIR_PUBLIC + user.profilePhoto
            }else{
              this.profilePhoto = 'static/img/face-0.jpg'
            }
              
          }
        })
      }
    },

    async mounted () {
      this.getUsersName ()
    },
  }

</script>
<style>
  .modal-footer {border: none !important}
</style>
